import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-popup-media',
  templateUrl: './popup-media.component.html',
  styleUrls: ['./popup-media.component.scss'],
})
export class PopupMediaComponent implements OnInit {
  constructor(
    private sanitizer: DomSanitizer,
    private dialogRef: MatDialogRef<PopupMediaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  isFrame = true;
  iframeURL: any = '';
  link_video: any = '';

  ngOnInit(): void {
    this.setLink(this.data.animal.link_video);
  }

  setLink(link: any) {
    let gerar_link;

    this.isFrame = link.includes('youtu');

    if (this.isFrame) {
      const param = link.includes('watch?v=')
        ? link.split('watch?v=')
        : link.split('youtu.be/');

      if (param.length > 1) {
        gerar_link =
          'https://www.youtube.com/embed/' + param[1] + '?enablejsapi=1';
      } else {
        gerar_link = link;
      }

      !this.iframeURL &&
        (this.iframeURL =
          this.sanitizer.bypassSecurityTrustResourceUrl(gerar_link));
    } else {
      this.iframeURL = '';
    }
  }

  chance(chance: 'yes' | 'no' | 'login', results?: any): void {
    this.dialogRef.close({ action: chance, results });
  }
}
